import { isNil } from 'lodash';
import { useMemo, useCallback } from 'react';
import { useTheme } from 'styled-components';

import { StyledTag, TextWrapper } from './QuizAverageTag.styles';

type Props = {
  score?: number;
  size?: number;
};

const FAILED_SCORE = 5;
const GOOD_SCORE = 7.5;

export const QuizAverageTag: React.FC<Props> = ({ score, size }) => {
  const { colors } = useTheme();

  const determineStyle = useCallback(() => {
    if (!isNil(score) && score < FAILED_SCORE) {
      return { color: colors.red6, backgroundColor: `${colors.red6}20` };
    }
    if (!isNil(score) && score < GOOD_SCORE) {
      return { color: colors.orange6, backgroundColor: colors.orange1 };
    }
    return { color: colors.green6, backgroundColor: colors.green1 };
  }, [score, colors]);

  const { color, backgroundColor } = useMemo(determineStyle, [determineStyle]);

  if (isNil(score)) return null;

  return (
    <StyledTag bordercolor={color} backgroundcolor={backgroundColor}>
      <TextWrapper size={size} color={color}>
        {score.toFixed(2)}
      </TextWrapper>
    </StyledTag>
  );
};
